export interface SharedData {
  id?: string;
  type?: 'user' | 'media';
  link?: string;
  view?: 'dialog' | 'curtain'
  title?: string,
}
